/**
 * Signal helpers for conversation completion detection.
 *
 * The AI embeds "# SIGNAL: COMPLETION" in its response when an activity is done.
 * These helpers strip signals before display and detect completion responses.
 */

const COMPLETION_SIGNAL = '# SIGNAL: COMPLETION';
const FUNCTION_CALL_PATTERN = /# FUNCTION_CALL:[^\n]*/g;

/**
 * Strip internal signals from text before displaying to users.
 * @param {string} text - Raw message text.
 * @returns {string} Cleaned text, or the original value if not a string.
 */
export function stripSignals(text) {
  if (!text || typeof text !== 'string') return text;
  return text
    .replace(/# SIGNAL: COMPLETION/g, '')
    .replace(FUNCTION_CALL_PATTERN, '')
    .trim();
}

/**
 * Check whether a parsed response indicates activity completion.
 * @param {Object} parsed - Parsed JSON message from the backend.
 * @returns {boolean}
 */
export function isCompletionResponse(parsed) {
  if (!parsed || typeof parsed !== 'object') return false;
  return !!(parsed.completionMessage || parsed.message === '[Test completed]');
}

export { COMPLETION_SIGNAL };
